import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseApiService } from '../../../core/base-api.service';
import { ApiResponse } from '../../api-response';
import { FleetMapPin } from '../models/monitoring.model';

/**
 * `GET /api/v1/device/monitoring/fleet-map` — whole-fleet, unpaginated pins
 * for the Monitor page's map. Tenant-scoped, requires the `viewer` role
 * (enforced server-side; nothing extra to do here). See `FleetMapPin`'s doc
 * comment for the response shape and known gaps (`error`/`shutdown` not
 * emitted yet, no guaranteed ordering — sort by `label` if you need one).
 */
@Injectable({ providedIn: 'root' })
export class FleetMapService extends BaseApiService {
  private readonly http = inject(HttpClient);
  private readonly fleetMapUrl = `${this.coreApiUrl}/api/v1/device/monitoring/fleet-map`;

  getFleetMap(): Observable<ApiResponse<FleetMapPin[]>> {
    return this.http.get<ApiResponse<FleetMapPin[]>>(this.fleetMapUrl);
  }
}
